import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/store';
import { ToastProvider } from './context/ToastContext';
import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { RewriteFrames } from '@sentry/integrations';
import LogRocket from './helpers/logrocket';
import { SocketProvider } from './context/SocketContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Initialize Sentry
Sentry.init({
  dsn: "https://d377690aa06c42e4978a32e066e3392c@sentry.io/99438", // Replace with your DSN from Sentry
  integrations: [
    new RewriteFrames({
      iteratee: (frame) => {
        if (frame.filename) {
          frame.in_app = /https?:\/\/(?:admin|api)\.radiofx\.co/i.test(frame.filename);
        }
        return frame;
      },
    }),
  ],
  blacklistUrls: [/localhost:4000/],
});



LogRocket.getSessionURL((sessionURL) => {
  Sentry.withScope((scope) => {
    scope.setExtra('sessionURL', sessionURL);
    Sentry.captureMessage('LogRocket session URL added');
  });
});


// Create a client
const queryClient = new QueryClient();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ToastProvider>
        <SocketProvider>
          <App />
        </SocketProvider>
      </ToastProvider>
    </Provider>
  </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
